'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgNavConnectedAssetsFill = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M21 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z" }),
  React__namespace.createElement("path", { fill: "#2D2E2E", fillRule: "evenodd", d: "M17 21a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM7 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z", clipRule: "evenodd" }),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M10.452 14.978a4 4 0 1 1-1.41-1.418l3.423-3.423 1.414 1.414-3.427 3.427Z" })
);

module.exports = SvgNavConnectedAssetsFill;
//# sourceMappingURL=NavConnectedAssetsFill.cjs.js.map
